import ApiService from "../ApiService";

const authorizationsService = {
  getAuthorizations(authorizationNumber) {
    return ApiService.get(`/authorization?authorizationNumber=${authorizationNumber}`);
  },

  bulkDeleteAuthorizacions(data) {
    return ApiService.post("/authorization/AuthorizationsDelete", data);
  },

  deleteAuthorizacion (data) {
    return ApiService.post(`/authorization/remove`, data);
  },

  getLogAuthorizationsDelete(){
    return ApiService.post("/authorization/LogChangeStatusAdmin");
  }


    
};

export default authorizationsService;
